import type { HandleDefinition, HandlePosition } from '../../widgets/types';

const spacing = 30;

export function handleOffsets(outputs: HandleDefinition[]) {
  const bySide = new Map<HandlePosition, HandleDefinition[]>();
  for (const output of outputs) {
    const side = bySide.get(output.position) ?? [];
    side.push(output);
    bySide.set(output.position, side);
  }

  return new Map(
    [...bySide.values()].flatMap((side) =>
      side.map((h, i) => [h.id, `${50 + (i - (side.length - 1) / 2) * spacing}%`] as const),
    ),
  );
}
